import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useGraphiQLActions, useGraphiQL } from "../provider.js";
import { Tooltip } from "../tooltip/index.js";
import { ExecuteButton } from "../execute-button/index.js";
import { GraphQLLogoIcon } from "../../icons/index.js";
import { clsx } from "clsx";
import { getRunBlockReason, resolveActiveOperation } from "../../utility/run-block.js";
/* empty css          */
const TopBar = ({
  version,
  brand
}) => {
  const {
    setTransportMethod
  } = useGraphiQLActions();
  const transport = useGraphiQL((state) => state.transport);
  const transportMethod = useGraphiQL((state_0) => state_0.transportMethod);
  const runDisabledReason = useGraphiQL((state_1) => getRunBlockReason(state_1.transportMethod, resolveActiveOperation(state_1.operations, state_1.operationName)));
  const url = (transport == null ? void 0 : transport.url) ?? "—";
  const method = transportMethod ?? "POST";
  const supportedMethods = (transport == null ? void 0 : transport.supportedMethods) ?? ["POST"];
  return /* @__PURE__ */ jsx(TopBarView, { version, brand, url, method, supportedMethods, runDisabledReason, runButton: /* @__PURE__ */ jsx(ExecuteButton, {}), onSetMethod: setTransportMethod });
};
const TopBarView = ({
  version,
  brand,
  url,
  method,
  supportedMethods,
  runDisabledReason = null,
  runButton,
  onSetMethod
}) => {
  const canSwitch = supportedMethods.length > 1;
  const isBlocked = runDisabledReason !== null;
  const nextMethod = supportedMethods[(supportedMethods.indexOf(method) + 1) % supportedMethods.length] ?? method;
  const switchTarget = isBlocked && supportedMethods.includes("POST") ? "POST" : nextMethod;
  return /* @__PURE__ */ jsxs("header", { className: "graphiql-top-bar", role: "banner", children: [
    /* @__PURE__ */ jsxs("div", { className: "graphiql-top-bar-brand", children: [
      brand ?? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(GraphQLLogoIcon, { className: "graphiql-top-bar-logo", "aria-hidden": "true" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-wordmark", children: "GraphiQL" })
      ] }),
      version && /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-version", children: version })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "graphiql-top-bar-divider", "aria-hidden": "true" }),
    canSwitch ? /* @__PURE__ */ jsx(Tooltip, { label: `Switch to ${switchTarget}`, children: /* @__PURE__ */ jsx("button", { type: "button", className: clsx("graphiql-top-bar-method-toggle", isBlocked && "graphiql-top-bar-method-toggle--attention"), onClick: () => onSetMethod(switchTarget), children: method }) }) : /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-method-label", children: method }),
    /* @__PURE__ */ jsx("div", { className: "graphiql-top-bar-endpoint", children: /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-endpoint-url", children: url }) }),
    runButton
  ] });
};
export {
  TopBar,
  TopBarView
};
//# sourceMappingURL=index.js.map
